// PURE easing for the board FX (juice.json `easing`, UX §5 "Easing defaults: out = Quad.out; pop =
// Back.out(1.7)"): Phaser's `Family.dir` names through cameraMath.easeByName, plus Back.out / Back.in with the
// data's overshoot (fx/ease.ts: the DOM snap-back uses the same formula). An unknown name throws at config
// time, never mid-tween.
import { backOut } from '../../fx/ease.ts';
import { easeByName } from '../cameraMath.ts';

export type EaseFn = (t: number) => number;

/** The easing called `name` ('Back.out' takes `overshoot`, juice.json easing.popOvershoot). */
export function easeFn(name: string, overshoot: number): EaseFn {
  if (name === 'Back.out') return (t) => backOut(t, overshoot);
  if (name === 'Back.in') return (t) => 1 - backOut(1 - t, overshoot);
  easeByName(name, 0); // throws on an unknown name
  return (t) => easeByName(name, t);
}

export const linear: EaseFn = (t) => (t < 0 ? 0 : t > 1 ? 1 : t);
